import { createAsyncThunk } from '@reduxjs/toolkit';
import { DiningTable } from './diningTableSlice';

const getToken = () => localStorage.getItem('accessToken');

export const fetchDiningTables = createAsyncThunk<DiningTable[], string>(
  'diningTable/fetchDiningTables',
  async (storeId, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/stores/${storeId}/dining-table/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error('Failed to fetch dining tables.');
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  }
);

export const addDiningTable = createAsyncThunk<DiningTable, { storeId: string; name: string }>(
  'diningTable/addDiningTable',
  async ({ storeId, name }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/stores/${storeId}/dining-table`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ storeId, name, sortIndex: 1 }), // 初期sortIndexを設定
      });
      if (!response.ok) {
        throw new Error('Failed to add dining table.');
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  }
);

export const deleteDiningTable = createAsyncThunk<string, { id: string; storeId: string }>(
  'diningTable/deleteDiningTable',
  async ({ id, storeId }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/stores/${storeId}/dining-table/${id}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error('Failed to delete dining table.');
      }
      return id; // 削除成功後に削除されたIDを返す
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  }
);

export const updateSortIndex = createAsyncThunk<void, { storeId: string; table: DiningTable }>(
  'diningTable/updateSortIndex',
  async ({ storeId, table }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/stores/${storeId}/dining-table/sort?id=${table.id}&sortIndex=${table.sortIndex}`,
        {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Failed to update sort index for table ID: ${table.id}`);
      }
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  }
);